import React, { Component } from 'react';
import { UISref, $state } from '../../../../router';
import './styles.css';

const ModuleActiveSessions = () => {
    return (
        <div className="ModuleActiveSessions">
            <UISref to="activeSessions">
                <a>
                    <div className="ModuleActiveSessions-body">
                        <div className="ModuleActiveSessions-title">Your Current Logins</div>
                        <div className="ModuleActiveSessions-subtitle">Browse your currently active sessions and manage API tokens</div>
                    </div>

                    <i className="fas fa-chevron-right"></i>
                </a>
            </UISref>
        </div>
    )
}

export default ModuleActiveSessions; 